export default {
  apiKey: 'AIzaSyAkTzdJ2DQxkHomBOlEM-wX0v27oECaeug',
  authDomain: 'mindoktor-dev.firebaseapp.com',
  databaseURL: 'https://mindoktor-dev.firebaseio.com',
  projectId: 'mindoktor-dev',
  storageBucket: 'mindoktor-dev.appspot.com',
  messagingSenderId: '315920674045',
  appId: '1:315920674045:web:5e02331f1312ecdf',
};
